<template>
  <div>
    <h5 class="header-stripe">
      <span>{{$t('INDENT_TRUCK_OUT')}}</span>
      <div class="action">
        <Button type="secondary" size="mini" @click="$emit('cancel-actions')"
          >{{$t('INDENT_CANCEL')}}</Button
        >
        <Button type="primary" size="mini" @click="truckOut()">{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Form :inline="true" class="form-default form-triple">
        <div class="form-item-group mb-0 d-flex">
          <FormItem :label="$t('INDENT_GATE')" disabled>
            <span class="form-value">{{ source.gatesName }}</span>
          </FormItem>
          <FormItem :label="$t('INDENT_DATE_AND_TIME')">
            <Date-Picker
              :format="datePickerFormat"
              v-model="truckOutDate"
              :readonly="avoidBackDate"
              :picker-options="pickerOptions1"
              type="datetime"
              :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
            >
            </Date-Picker>
          </FormItem>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    getBackDateConfig: {
      type: Object,
      default: () => {},
    },
    arrivedDate: {
      type: String,
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
  },
  data() {
    return {
      truckOutDate: new Date(),
    };
  },
  methods: {
    async truckOut() {
      const data = {};
      data.unique_id = this.source._id;
      data.dispatched_at = this.avoidBackDate ? new Date() : this.truckOutDate;
      this.$emit("truckOut", data);
    },
  },
  computed: {
    avoidBackDate() {
      return this.getBackDateConfig.truck_out;
    },
    pickerOptions1() {
      const arrivedDate = this.arrivedDate;
      return {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date(arrivedDate).getTime() - 8.64e7
          );
        },
      };
    },
  },
};
</script>
